import { Spinner } from "@components/misc"
import { BasicLink } from "@components/typography"
import { FlexBox } from "@components/wrapper"
import { Accordion, AccordionHead, AccordionItem, AccordionItemPanel } from "@harisenin/component"
import { useSchools } from "@hooks/data"
import { useCourseCategory } from "@lib/hooks/data/useCourse"
import clsx from "clsx"
import React from "react"

const CategoryAccordionHead: React.FC<any> = ({ children }) => {
  return (
    <AccordionHead
      chevronDirection="down"
      headClassName={clsx("!py-2.5 !px-4 flex items-center")}
      textClassName="font-semibold text-sm"
      buttonClassName="text-sm"
    >
      {children}
    </AccordionHead>
  )
}

const CategoryAccordionPanel: React.FC<any> = ({ children }) => {
  return (
    <AccordionItemPanel className="px-5">
      <FlexBox direction="col">
        {children}
        <div className="h-4" />
      </FlexBox>
    </AccordionItemPanel>
  )
}

export const CategoryAccordion = () => {
  const { data: courses, isLoading: isFetchingCourses } = useCourseCategory()
  const { data: schools, isLoading: isFetchingSchools } = useSchools("BOOTCAMP")
  const { data: proClass, isLoading: isFetchingProClass } = useSchools("PRO_CLASS")

  const LoadingData = () => {
    return (
      <FlexBox justify="center" align="center" className="w-full h-[200px]">
        <Spinner />
      </FlexBox>
    )
  }

  return (
    <Accordion>
      <AccordionItem key="1" className="bg-primary-grey rounded mb-3.5">
        <CategoryAccordionHead>Bootcamp</CategoryAccordionHead>
        <CategoryAccordionPanel>
          {isFetchingSchools ? (
            <LoadingData />
          ) : (
            schools.map((value, index) => (
              <BasicLink
                href={`/school/bootcamp/${value.product_slug}`}
                key={index}
                className="font-semibold text-green text-sm mt-2.5 mb-0.5"
                isExternal
              >
                {value.product_name}
              </BasicLink>
            ))
          )}
        </CategoryAccordionPanel>
      </AccordionItem>

      <AccordionItem key="2" className="bg-primary-grey rounded mb-3.5">
        <CategoryAccordionHead>ProClass</CategoryAccordionHead>
        <CategoryAccordionPanel>
          {isFetchingProClass ? (
            <LoadingData />
          ) : (
            proClass.map((value, index) => (
              <BasicLink
                href={`/school/proclass/${value.product_slug}`}
                key={index}
                className="font-semibold text-green text-sm mt-2.5 mb-0.5"
                isExternal
              >
                {value.product_name}
              </BasicLink>
            ))
          )}
        </CategoryAccordionPanel>
      </AccordionItem>

      <AccordionItem key="3" className="bg-primary-grey rounded mb-3.5">
        <CategoryAccordionHead>Video Course</CategoryAccordionHead>
        <CategoryAccordionPanel>
          {isFetchingProClass ? (
            <LoadingData />
          ) : (
            courses.map((value, index) => (
              <BasicLink
                href={`/learning/category/${value.category_slug}`}
                key={index}
                className="font-semibold text-green text-sm mt-2.5 mb-0.5"
                isExternal
              >
                {value.category_name}
              </BasicLink>
            ))
          )}
        </CategoryAccordionPanel>
      </AccordionItem>
    </Accordion>
  )
}
